/*! dependencies: cash */

instant.vimeo = {
  status: {
    apiLoading: false,
    apiLoaded: false
  },
  init: function () {
    instant.vimeo.addCookieInformationEvents();
  },
  bindEvents: function () {
    cash('body').on('mouseenter', '.media--vimeo', instant.vimeo.loadApi);
    cash('body').on('click', '.media--vimeo', function () {
      if (Cookiebot.consent.marketing !== true) {
        alert(instant.settings.youMustGiveCookieConsent);
        Cookiebot.renew();
      } else {
        var video = cash(this);
        instant.vimeo.startVideo(video);
      }
    });
  },
  startVideo: function (mediaEle) {
    if (instant.vimeo.status.apiLoaded) {
      var iframe = mediaEle.find('iframe'),
        player = new Vimeo.Player(iframe[0]);

      player.play().then(function () {
        if (mediaEle.is('.enable-controls')) {
          mediaEle.find('.video-overlay').remove();
        } else {
          mediaEle.find('.video-overlay').addClass('opacity-0').removeClass('cursor-pointer');
        }
      });
    } else {
      mediaEle.addClass('media--vimeo--queued');
      instant.vimeo.loadApi();
    }
  },
  loadApi: function () {
    if (!instant.vimeo.status.apiLoaded && !instant.vimeo.status.apiLoading) {
      var tag = document.createElement('script');
      tag.onload = instant.vimeo.apiLoaded;
      tag.src = 'https://player.vimeo.com/api/player.js';

      document.head.appendChild(tag);

      instant.vimeo.status.apiLoading = true;
    }
  },
  apiLoaded: function () {
    instant.vimeo.status.apiLoaded = true;
    instant.vimeo.status.apiLoading = false;

    cash('.media--vimeo--queued').each(function () {
      var video = cash(this);

      instant.vimeo.startVideo(video);
      video.removeClass('media--vimeo--queued');
    });
  },
  addCookieInformationEvents: function () {
    window.addEventListener('CookiebotOnConsentReady', function () {
      if (Cookiebot.consent.marketing === true) {
        console.log('cookie consent given');
        var iframes = cash('.media--vimeo iframe');
        for (i = 0; i < iframes.length; i++) {
          var iframe = cash(iframes[i]);
          iframe.attr('src', iframe.data('src'));
        }
      }
    }, false);
    instant.vimeo.bindEvents();
  }
}